export default __webpack_public_path__ + "static/media/work6.6dffcefa.png";